import { ReactNode } from 'react'

export const TileHeader = (props: { children: ReactNode }) => {
  return <div className='tile-header'>{props.children && <h1>{props.children}</h1>}</div>
}
